angular.module("vgresiduos").controller("iframeAngularSingletonController", [
	"$scope",
	"$sce",
	"accountService",
	"localStorageWithTimeoutService",
	"translationService",
	"rootScopeService",
	"$interval",
	"$state",
	"$q",
	"$rootScope",
	function (
		$scope,
		$sce,
		accountService,
		localStorageWithTimeoutService,
		translationService,
		rootScopeService,
		$interval,
		$state,
		$q,
		$rootScope
	) {
		const eventHandler = {
			REDIRECT: redirectTo,
			READY: syncLocalStorage,
			REDIRECT_BLANK: redirectBlank,
			REDIRECT_PAGE_URL: redirectToPageUrl,
			ON_SUCCESS: executeOnSuccessCall,
			ON_CANCEL: executeOnCancelCall,
			GO_BACK: goBack,
			CHANGE_CLIENT: changeOrganizationUnitHandler,
			REFRESH_PREFERENCES: refreshPreferencesHandler,
			UPDATE_TOKEN: updateTokenHandler,
			SEARCH_VERTA: searchInVerta,
			PREVIEW_ALERT_NOTIFICATION: previewAlertNotification,
			HEIGHT_FRAME: executeHeightFrame,
			RELOAD_PARENT: reloadParent
		};

		$scope.labels = $rootScope.labels;

		const iframeId = Vgr.constants.IframeSingletonId;
		let refreshTokenTimer;
		let currentPath = Vgr.constants.IframeSingletonBlankPage;

		this.$onInit = function () {
			window.addEventListener("message", iframeEventHandler);
			refreshTokenTimer = $interval(refreshFrameToken, 1000 * 5 * 60); //Refresh Angular token every 5 minutes

			// Load with "/blank" (BlankPageComponent) to avoid initializing "/" (HomePageComponent) before redirect
			const finalUrl = `${Vgr.constants.newAngularUrl}blank`;
			$scope.src = $sce.trustAsResourceUrl(finalUrl);
		};

		$scope.showFrame = function () {
			return currentPath !== Vgr.constants.IframeSingletonBlankPage;
		};

		this.$onDestroy = function () {
			window.removeEventListener("message", iframeEventHandler);
			$interval.cancel(refreshTokenTimer);
			watchFrameRedirection();
			watchChangeOrganizationUnit();
			watchChangeOrganizationUnitInfo();
		};

		function iframeEventHandler(event) {
			if (Vgr.constants.newAngularUrl.includes(event.origin) && event.data.type) {
				const handler = eventHandler[event.data.type];
				if (typeof handler !== "function") {
					throw new Error(
						"iframeEventHandler: no handler registered for event.data.type=" +
							JSON.stringify(event.data ? event.data.type : "NO event.data") +
							" (event.data=" +
							JSON.stringify(event.data ?? "NO event.data") +
							")"
					);
				}
				handler(event);
			}
		}

		function searchInVerta(event) {
			if (event && event.data && event.data.payload) {
				$rootScope.$emit(Vgr.constants.evtSearchInVerta, event.data.payload.searchText);
			}
		}

		function previewAlertNotification(event) {
			if (event && event.data && event.data.payload && event.data.payload.data) {
				$rootScope.$emit(Vgr.constants.evtPreviewAlertNotification, event.data.payload.data);
			}
		}

		function changeOrganizationUnitHandler(event) {
			const organizationId = event.data.payload.organizationId;
			const organizationUnitId = event.data.payload.organizationUnitId;
			const redirect = event.data.payload.redirect ?? "unitEdit";
			const routeData = event.data.payload.routeData;
			const ignoreErrorMessageHandling = false;

			accountService.changeClient(organizationId, organizationUnitId, ignoreErrorMessageHandling).then(function () {
				$state.go(redirect, {
					id: organizationUnitId,
					...routeData
				});
			});
		}

		function refreshPreferencesHandler(event) {
			const preference = event.data.payload.preference;
			if (preference == "STORAGE") {
				rootScopeService.setStoragePreferences(null);
			} else if (preference == "DISPOSAL") {
				rootScopeService.setDisposalPreferences(null);
			} else if (preference == "STOCK") {
				rootScopeService.setStockControlPreferences(null);
			}
		}

		function executeOnSuccessCall(event) {
			if (event && event.data && event.data.payload && event.data.payload.createVehicle) {
				$scope.$emit(Vgr.constants.evtIframeOnSuccessCreateVehicle, event.data.payload);
			} else if (event && event.data && event.data.payload && event.data.payload.createDriver) {
				$scope.$emit(Vgr.constants.evtIframeOnSuccessCreateDriver, event.data.payload);
			} else {
				$scope.$emit(Vgr.constants.evtIframeOnSuccessCallBack, event);
			}
		}

		function executeOnCancelCall(event) {
			if (event && event.data && event.data.payload && event.data.payload.createVehicle) {
				$scope.$emit(Vgr.constants.evtIframeOnCancelCreateVehicle, event);
			} else if (event && event.data && event.data.payload && event.data.payload.createDriver) {
				$scope.$emit(Vgr.constants.evtIframeOnCancelCreateDriver, event);
			}
		}

		function redirectTo(event) {
			$state.go(event.data.payload.state, event.data.payload.routeData);
		}

		function redirectBlank(event) {
			window.open(event.data.payload.blankUrl, "_blank");
		}

		function redirectToPageUrl(event) {
			window.open(event.data.payload.pageUrl, "_self");
		}

		function getPermissions() {
			return localStorageWithTimeoutService.getFromCacheWithExpiry(
				Vgr.constants.authentication.permissions,
				Vgr.constants.events.cache.userPermission
			);
		}
		function getFeatureToggle() {
			return localStorageWithTimeoutService.getFromCacheWithExpiry(
				Vgr.constants.authentication.featureToggle,
				Vgr.constants.events.cache.featureToggle
			);
		}

		function refreshFrameToken() {
			getBearerToken().then((token) => {
				if (token) {
					sendMessageToFrame(Vgr.enumerations.messageTypes.SET_BEARER_TOKEN, { token: token });
				}
			});
		}

		function syncLocalStorage() {
			getBearerToken().then((token) => {
				if (!token) {
					return;
				}
				const currentLanguage = translationService.getLanguage();
				const userPermissions = getPermissions();
				const organization = accountService.getCurrentClient();
				const featureToggles = getFeatureToggle();
				const loggedUser = accountService.getLoggedAccount();
				const currentOrganizationUnit = accountService.getCurrentClient();
				sendMessageToFrame(Vgr.enumerations.messageTypes.SYNC_LOCAL_STORAGE, {
					userPermissions,
					organization,
					featureToggles,
					currentLanguage,
					loggedUser,
					token,
					currentOrganizationUnit
				});
			});
		}

		function getBearerToken() {
			if (!document.getElementById(iframeId)) {
				return;
			}

			const deferred = $q.defer();
			if (!accountService.isLoggedInIdp()) {
				deferred.resolve(undefined);
				return deferred.promise;
			}
			accountService.getTokenRefreshingIfNecessary().then((tokens) => {
				if (tokens) {
					deferred.resolve(tokens.accessToken);
				} else {
					deferred.resolve();
				}
			});
			return deferred.promise;
		}

		function sendMessageToFrame(type, payload) {
			document.getElementById(iframeId).contentWindow.postMessage(
				{
					type: type,
					payload: payload
				},
				Vgr.constants.newAngularUrl
			);
		}

		function updateTokenHandler() {
			syncLocalStorage();
		}

		$(`#${iframeId}`).ready(function () {
			$(`#${iframeId}`).on("load", function () {
				if (Vgr.util.tempLastRoute) {
					Vgr.util.redirectSingleton($rootScope, Vgr.util.tempLastRoute.route, Vgr.util.tempLastRoute.queryString);
					Vgr.util.tempLastRoute = null;
				}
			});
		});

		const watchChangeOrganizationUnit = $rootScope.$on(Vgr.constants.evtChangeLoggedClient, function () {
			syncLocalStorage();
		});

		const watchChangeOrganizationUnitInfo = $rootScope.$on(Vgr.constants.evtChangeLoggedClientInfo, function () {
			syncLocalStorage();
		});

		const watchFrameRedirection = $rootScope.$on("REDIRECT_FRAME_SINGLETON", function (_event, params) {
			createQueryParamsV2(params.queryString).then((queryParams) => {
				currentPath = params.route;
				redirectSingleton(params.route, queryParams);
			});
		});

		function redirectSingleton(route, params) {
			sendMessageToFrame(Vgr.enumerations.messageTypes.REDIRECT_SINGLETON, {
				route: route,
				params: params
			});
		}

		function createQueryParamsV2(queryString) {
			const deferred = $q.defer();
			const queryParams = {};
			const withHeader = $scope.ctrl.withHeader ? $scope.ctrl.withHeader : false;
			queryParams.withHeader = withHeader;
			if (queryString) {
				queryString.forEach((queryStringParameter) => {
					if (queryStringParameter.key && queryStringParameter.value) {
						queryParams[queryStringParameter.key] = queryStringParameter.value;
					}
				});
			}

			const currentOrganizationUnit = accountService.getCurrentClient();
			if (currentOrganizationUnit) {
				const organizationId = currentOrganizationUnit.organization.id;
				const organizationUnitId = currentOrganizationUnit.id;
				const organizationUnitCode = currentOrganizationUnit.code;
				queryParams.organizationId = organizationId;
				queryParams.organizationUnitId = organizationUnitId;
				queryParams.organizationUnitCode = organizationUnitCode;
			}
			deferred.resolve(queryParams);
			return deferred.promise;
		}

		function goBack() {
			window.history.back();
		}

		/**
		 * O iframe caiu numa rota que ele nao conhece. O caso esmagadoramente comum e esta aba estar
		 * rodando um bundle antigo do portal: as rotas do Angular vivem hardcoded nos `*Ctrl.js` de
		 * `views/newAngular/`, entao um deploy que renomeia rota so chega aqui com um load completo.
		 *
		 * Recarrega no maximo uma vez por sessao da aba. Se depois do reload o iframe reclamar de novo,
		 * a rota realmente nao existe e a tela de "nao encontrada" e a resposta correta. Sem
		 * `sessionStorage` nao ha como garantir isso, e ai nao recarrega: um laco de reload seria pior
		 * que a tela quebrada.
		 */
		function reloadParent() {
			try {
				if (sessionStorage.getItem(Vgr.constants.IframeStaleRouteReloadKey)) {
					return;
				}
				sessionStorage.setItem(Vgr.constants.IframeStaleRouteReloadKey, "true");
			} catch (e) {
				return;
			}

			window.location.reload();
		}

		function executeHeightFrame(event) {
			if (event && event.data && event.data.payload && event.data.payload.height) {
				$scope.$emit(Vgr.constants.evtIframeHeight, event);
			}
		}
	}
]);
